<div class="modal-box modal_box">
  <div class="modal_header bg_primary_light">
    <a class="btnn close_btn" mat-dialog-close>
      <mat-icon>{{ 'close' | translate }}</mat-icon>
    </a>
    <figure (click)="LoginModal()" class="back_icon">
      <img [src]="assetsConst.backIcon" alt="img" />
    </figure>

    <figure>
      <img [src]="assetsConst.Logo" />
    </figure>
  </div>
  <div class="modal_body">
    <div class="modal_subtitle">
      <h3>{{ 'forgotPassword' | translate }}</h3>
      <p>{{ 'signInDescription' | translate }}</p>
    </div>
    <form [formGroup]="forgotPasswordFormGroup" (ngSubmit)="onSubmit()">
      <div class="gap_m form_filed">
        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [placeholder]="'enterEmail' | translate"
              type="email"
              formControlName="email"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              forgotPasswordFormGroup['controls']['email'].hasError(
                'required'
              ) && submitted
            ">
            {{ 'email' | translate }} {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              forgotPasswordFormGroup['controls']['email'].hasError(
                'pattern'
              ) && submitted
            ">
            {{ 'PleaseEnterValid' | translate }}
            {{ 'email' | translate }}
          </mat-error>
        </div>

        <div class="submit_btn mt_20">
          <button class="btnn btn_primary" type="submit">
            {{ 'continue' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
